import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Overview from './components/Overview';
import Features from './components/Features';
import Catalog from './components/Catalog';
import Device from './components/Device';
import Guide from './components/Guide';
import Ranking from './components/Ranking';
import Faq from './components/Faq';
import Entrance from './components/Entrance';
import SiteFooter from './components/SiteFooter';

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 flex flex-col">
      <Navbar />
      <main className="w-full flex-1">
        <Hero />
        <Overview />
        <Features />
        <Catalog />
        <Device />
        <Guide />
        <Ranking />
        <Faq />
        <Entrance />
      </main>
      <SiteFooter />
    </div>
  );
}